import { FC, ReactElement, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Typography } from '@altermaind/web/ui';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { Menu } from '../Menu';

type Props = {
  pageTitle: string;
  headerChildren?: ReactElement;
  roleHeader?: string;
  roleHeading?: string;
};

export const Header: FC<Props> = ({
  pageTitle,
  headerChildren,
  roleHeader = 'banner',
  roleHeading = 'heading',
}) => {
  const t = useTranslations('general');
  const { isDesktop } = useBreakingPoints();
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleMenuToggle = () => {
    setToggleMenu(!toggleMenu);
    document.body.style.overflow = !toggleMenu ? 'hidden' : '';
  };

  return (
    <Box role={roleHeader} display='flex' pl='s' pr='s' style={{ boxSizing: 'border-box' }}>
      <Box
        display='flex'
        width='100%'
        py='s'
        mb='l'
        borderBottomStyle='solid'
        borderBottomWidth='1px'
        borderBottomColor='grey/dark/background'
      >
        {isDesktop ? (
          <Box display='flex' flex='auto' alignContent='flex-start' alignItems='center'>
            <Typography
              // @ts-ignore
              role={roleHeading}
              aria-level='1'
              variant='special'
              mt='xs'
              data-testid='page-title'
            >
              {pageTitle}
            </Typography>
          </Box>
        ) : (
          <Box display='flex' flex='auto' alignContent='flex-start' alignItems='center'>
            <Asset mr='xxs' domain='images' name='logoAltermaind' width='xl' />
            <Typography onClick={handleMenuToggle} ml='xxxs' variant='p2/light'>
              {t('menu')}
            </Typography>
          </Box>
        )}
        {toggleMenu && !isDesktop && (
          <Box
            position='absolute'
            left='0'
            right='0'
            top='0'
            backgroundColor='grey/dark'
            height='100%'
            zIndex='100'
          >
            <Box p='s'>
              <Menu handleMenuToggle={handleMenuToggle} />
            </Box>
          </Box>
        )}
        <Box display='flex' alignContent='flex-end'>
          {headerChildren}
        </Box>
      </Box>
    </Box>
  );
};
